import BrowserDetector from '@/scripts/helpers/browser-detector';

const _initUIBindings = function _initUIBindings() {
  $('.banner__cta').click(function openMobileStore(event) {
    const $this = $(this);
    const writeUp = $('.banner__writeup').text();
    const cta = $this.text();

    ga('send', 'event', 'app-campaign', 'app-banner', writeUp + ' - ' + cta);

    if (BrowserDetector.os() === 'AndroidOS') {
      window.open($this.data('href-android'));
      return false;
    } else if (BrowserDetector.os() === 'iOS') {
      window.open($this.data('href-ios'));
      return false;
    } else {
      window.open($this.attr('href'));
      return false;
    }
  });
};

// const _initBranchLinks = function _initBranchLinks() {
//   const $btnGetApp = $('.banner__cta');
//   const tags = [];
//   const writeUp = $('.banner__writeup').text();
//   const cta = $btnGetApp.text();
//   const data = {
//     $desktop_url: 'https://www.viddsee.com',
//   };

//   tags.push(writeUp + ' - ' + cta);

//   if ($btnGetApp.data('video-uid')) {
//     data['$deeplink_path'] = 'video/' + $btnGetApp.data('video-uid');
//   }

//   if ($btnGetApp.data('video-title')) {
//     tags.push($btnGetApp.data('video-title'));
//   }

//   if ($btnGetApp.data('community')) {
//     data['$deeplink_path'] = 'community';
//     tags.push('community');
//   }

//   if ($btnGetApp.data('community-question-id')) {
//     data['$deeplink_path'] = 'discussion/' + $btnGetApp.data('community-question-id');
//   }

//   if ($btnGetApp.data('community-question-title')) {
//     tags.push($btnGetApp.data('community-question-title'));
//   }

//   branch.link({
//     channel: 'video',
//     feature: 'app-banner',
//     tags,
//     data,
//   }, (err, link) => {
//     if (!err) {
//       $('.banner__cta')
//         .data('href-android', link)
//         .data('href-ios', link);
//     }
//   });
// };

const _initBannerText = function _initBannerText() {
  const copy = [
    I18n.t('javascript.video.download_app.copy.option_0'),
    I18n.t('javascript.video.download_app.copy.option_1'),
  ];
  const cta = [
    I18n.t('javascript.video.download_app.cta.option_0'),
    I18n.t('javascript.video.download_app.cta.option_1'),
  ];

  $('.banner__writeup').text(copy[Math.round(Math.random())]);
  $('.banner__cta').text(cta[Math.round(Math.random())]);
};

const Banner = {
  init(opts) {
    // if (BrowserDetector.os() === 'AndroidOS' || BrowserDetector.os() === 'iOS') {
    //   _initBranchLinks();
    // }
    _initBannerText();
    _initUIBindings();
  },
};

export default Banner;
